import { useState, useEffect, createContext, React } from 'react';
import { Link } from 'react-router-dom';
import { withAuthenticator, TextAreaField, Button, View } from '@aws-amplify/ui-react';


import { getChannel as getDatabaseChannel, getVideosFromChannel, getChannelStatistics, deleteChannel } from '../../services/DatabaseService';
import { registerChannel } from '../../services/AdminService';
import {
  BrowserRouter as Router,
  useLocation
} from "react-router-dom";


function useQuery() {
  const { search } = useLocation();

  var s = new URLSearchParams(search);
  return s.get("search");
}

const ChannelList = ({ signOut, user }) => {
  const [channelDbDetails, setChannelDbDetails] = useState([]);
  const [channelStatistics, setChannelStatistics] = useState([]);
  const [videos, setVideos] = useState([]);
  const [error, setError] = useState(null);

  let channelId = useQuery();


  const myStyle = {
    color: "white",
    backgroundColor: "silver",
    padding: "10px",
    fontFamily: "Sans-Serif"
  };


  useEffect(() => {
    (async () => {

      try {
        loadChannelFromDb(channelId);
        loadChannelStatisticsFromDb(channelId);
        var videos = await getVideosFromChannel(channelId)

        if (videos) {
          setVideos(videos);
        }

      } catch (err) {
        console.log("error" + error.message)
        setError(err);
      }

    })();
  }, [channelId])

  const loadChannelFromDb = async (channelId) => {
    var dbChannel = await getDatabaseChannel(channelId)
    setChannelDbDetails(dbChannel);
  }

  const loadChannelStatisticsFromDb = async (channelId) => {
    var dbStatistics = await getChannelStatistics(channelId)
    setChannelStatistics(dbStatistics);
  }


  const doDeleteChannel = async (channelId) => {
    await deleteChannel(channelId)
    setChannelDbDetails(null);
  }

  const doRegisterChannel = async (channelId) => {
    var dbChannel = await registerChannel({ "channelId": channelId });
    await loadChannelFromDb(channelId);
  }


  if (error) {
    return <span>Caught an error: {error.message}</span>;
  }


  return (
    <div>
      <h1>Channel Details</h1>

      {channelDbDetails ?
        <p>

          <ChannelDbDetails>{channelDbDetails}</ChannelDbDetails>
          <ChannelStatistics channel={channelDbDetails} statistics={channelStatistics} ></ChannelStatistics>
          <Button onClick={() => doDeleteChannel(channelId)}>Delete channel</Button>
          <Button onClick={() => doDeleteChannel(channelId)}>Delete All videos</Button>
          <Button onClick={() => doDeleteChannel(channelId)}>Crawl All videos</Button>
          <Button onClick={() => doDeleteChannel(channelId)}>Update Latest videos</Button>
          <Button onClick={() => doDeleteChannel(channelId)}>Sync All videos</Button>

          {/* <TextAreaField
            value={JSON.stringify(channelDbDetails, null, 2)}
            rows={15}
          /> */}
        </p>
        :
        <>
          <Button onClick={() => doRegisterChannel(channelId)}>Register channel</Button>
        </>}


      <h2>Videos</h2>


      <>
        {channelDbDetails
          && videos && videos.length != 0 ?
          videos.map((entry, id) => (
            <View
              // height="2rem"
              // width="5rem"
              backgroundColor={'silver'}
              key={id}
            >
              <p>#{id} - {entry.title}</p>
              <img referrerPolicy="no-referrer" src={atob(entry.image)} width={'250px'}></img>

              {/* <YouTube videoId={entry.videoId} />; */}

            </View>
          ))
          :
          <> <p> No results </p>  </>
        }
      </>

    </div>
  );
};


const ChannelDbDetails = ({ children }) => {

  return (
    <p>
      <img referrerPolicy="no-referrer" src={children.defaultImage ? atob(children.defaultImage) : ''}></img><br />
      videoId:  <b> <a href={"/mytube/youtube/channeldetails?search=" + children.channelId}>{children.channelId}</a>   </b> <br />
      title:    <b>{children.title} </b> <br />
      upload:   <b>{children.upload} </b> <br />
    </p>
  );
};

const ChannelStatistics = ({ channel, statistics }) => {

  return (
    <p>
      video subs:    <b>{channel.videoCount} </b> <br />
      video count:   <b>{channel.subscriberCount} </b> <br />
      db registered videos:   <b>{statistics.totalRegisteredVideos ? statistics.totalRegisteredVideos : ''} </b> <br />
    </p>
  );
};

export default ChannelList;